/**
 * Route for `campaign-states`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CampaignStatesPage } from "../features/campaign-states/CampaignStatesPage";

export const campaignStatesRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/campaign-states",
	component: CampaignStatesPage,
});

export default campaignStatesRoute;
